export default "---\nversion: 1.0\n\nrender:\n  H1: this is H1\n";